export var EOwnerComplaintType = /*#__PURE__*/function (EOwnerComplaintType) {
  EOwnerComplaintType["WriteMessage"] = "writeMessage";
  EOwnerComplaintType["CreateComplaint"] = "createComplaint";
  return EOwnerComplaintType;
}({});